import { render, staticRenderFns } from "./quantities.vue?vue&type=template&id=56b0689c&scoped=true"
import script from "./quantities.vue?vue&type=script&lang=js"
export * from "./quantities.vue?vue&type=script&lang=js"
import style0 from "./quantities.vue?vue&type=style&index=0&id=56b0689c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0689c",
  null
  
)

export default component.exports